import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { workExperience } from '../../data';

export const ExperienceTimeline = () => (
    <VerticalTimeline layout="1-column" className="vertical-timeline-experience">
        {workExperience.map((experience) => (
            <VerticalTimelineElement className="vertical-timeline-element" date={experience.date} icon={<experience.icon />} iconStyle={{ background: 'rgb(135, 135, 135)', color: '#fff' }}>
                <h3 className="vertical-timeline-element-title">{experience.title}</h3>
                <h4 className="vertical-timeline-element-subtitle">{experience.company}</h4>
                <p>{experience.description}</p>
            </VerticalTimelineElement>
        ))}
    </VerticalTimeline>
);
